import { render, staticRenderFns } from "./photo-pachymetry.vue?vue&type=template&id=26ba9d8f&scoped=true&"
import script from "./photo-pachymetry.vue?vue&type=script&lang=js&"
export * from "./photo-pachymetry.vue?vue&type=script&lang=js&"
import style0 from "./photo-pachymetry.vue?vue&type=style&index=0&id=26ba9d8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ba9d8f",
  null
  
)

export default component.exports